/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

export enum EEdmDeliveryInfoFields {
	operator = 'operator',
	name = 'name',
	phone = 'phone',
	email = 'email',
}

export enum EEdmOperatorConnectionMode {
	addOperator = 'addOperator',
	changeOperator = 'changeOperator',
}

export enum EEdmErrorCode {
	dependentEdmWay = 'dependentEdmWay',
	dependentPaperWays = 'dependentPaperWays',
	edmConnectionNotFound = 'edmConnectionNotFound',
}
